<template>
	<span class="ai_md_inline"
		><template v-for="(node, index) in nodes"
			><span v-if="node.type === 'text'" :key="`t${index}`">{{
				node.value
			}}</span
			><code
				v-else-if="node.type === 'codeSpan'"
				:key="`c${index}`"
				class="ai_md_code"
				>{{ node.value }}</code
			><strong v-else-if="node.type === 'strong'" :key="`s${index}`"
				><AiMarkdownInline :nodes="node.children"
			/></strong
			><em v-else :key="`e${index}`"
				><AiMarkdownInline :nodes="node.children" /></em></template
	></span>
</template>

<script>
// Renderiza los nodos INLINE del AST de `utils/markdown` (fase 12 del plan
// docs/PLAN_PHI_NIVEL3.md). Recursivo: strong/em contienen más inline.
//
// Sin `v-html`: cada nodo es un componente/elemento real, así que el texto del
// modelo nunca se interpreta como markup (invariante 11 del plan).
//
// Los tags van pegados (`><` al final de línea) a propósito: evita que el
// compilador de templates inyecte espacios entre nodos —"**hola** mundo" no
// debe quedar como "hola  mundo"— sin depender del modo `whitespace` del build.
export default {
	name: "AiMarkdownInline",
	props: {
		nodes: {
			type: Array,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.ai_md_inline {
	// El span es sólo un contenedor: no debe romper el flujo del texto.
	display: inline;
}

.ai_md_code {
	padding: 1px 5px;
	border-radius: 5px;
	background: var(--ai-chat-code-bg);
	color: var(--ai-chat-ink);
	font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
	font-size: 0.92em;
	word-break: break-word;
}
</style>
